import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../../common/services/data.service';

@Component({
    selector: 'cop-feedback-form',
    templateUrl: './feedback-form.component.html',
    styleUrls: ['./feedback-form.component.scss'],
    standalone: false
})

export class FeedbackFormComponent implements OnInit {

  formId: string = null;
  feedbackForm: UntypedFormGroup;
  ratings: number = 0;
  starArr: number[] = [1, 2, 3, 4, 5];
  btnDisable: boolean = true;
  fieldDisable: boolean = false;
  emailPattern: RegExp = /[a-zA-Z0-9-.-_(\\+)]{1,}@[a-zA-Z0-9.-]{2,253}[.]{1}[a-zA-Z]{2,}/; //Avaya email pattern
  hideForm: boolean = false;
  apiFailMsg: boolean = false;
  mainPageLoader: boolean = false;
  email: string = null;

  constructor(private router: ActivatedRoute, private ds: DataService) { }

  ngOnInit() {
    this.mainPageLoader = true;
    this.feedbackForm = new UntypedFormGroup({
      userReview: new UntypedFormControl("", Validators.required),
      userEmail: new UntypedFormControl("", [Validators.required, Validators.pattern(this.emailPattern)])
    });

    this.router.queryParams.subscribe(params => {
      if(params.formId)
        this.formId = params.formId;
      if(params.email) {
        this.email = params.email;
        this.fieldDisable = true;
      }
    });
    setTimeout(() => {
      if(this.email) {
        this.feedbackForm.setValue({ userReview: "", userEmail: this.email });
        this.feedbackForm.controls["userEmail"].disable();
      }
      this.mainPageLoader = false;
    }, 2000);
  }

  onClick(idx: number) {
    this.ratings = idx;
  }

  onSubmit() {
    if(!this.formId) {
      alert("Form-Id is not patched with form. Please contact Avaya Customer-Care.");
      return;
    } else {
      this.mainPageLoader = true;
      let payload = {
        "formId": this.formId,
        "source": "Onecare",
        "questions": [
          { "qname": "summary", "qvalue":this.feedbackForm.getRawValue().userReview ? this.feedbackForm.getRawValue().userReview : "", "qcontext": "summary" }
        ],
        "additionalinformation": [
          { "name": "ratings", "value": this.ratings },
          { "name": "email", "value": this.feedbackForm.getRawValue().userEmail }
        ]
      };

      this.ds.getITSSToken().subscribe((res: any) => {
        if(res && res.token) {
          this.ds.submitJiraTicket(payload, res.token).subscribe((data: any) => {
            if(data.returnCode === 0) {
              this.apiFailMsg = false;
              this.hideForm = true;
            } else {
              this.apiFailMsg = true;
              this.hideForm = false;
            }
            this.mainPageLoader = false;
          }, (error) => {
            this.mainPageLoader = false;
            this.apiFailMsg = true;
            this.hideForm = false;
            console.error("Form can not submit...", error);
          });
        } else {
          this.mainPageLoader = false;
          this.apiFailMsg = true;
          this.hideForm = false;
          console.error("Form can not be submit, token fetch failed...", res);
        }
      })
    }
  }
}
